const compatModules = {};import * as Mod1 from "./discourse/components/waze-copy-logs-button";
compatModules["discourse/components/waze-copy-logs-button"] = Mod1;

export * as discourse$components$waze__copy__logs__button$$__module from "./discourse/components/waze-copy-logs-button";
export {
default as discourse$components$waze__copy__logs__button$$default
} from "./discourse/components/waze-copy-logs-button";
import * as Mod2 from "./discourse/connectors/category-custom-settings/waze-forms-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/waze-forms-settings"] = Mod2;

export * as discourse$connectors$category__custom__settings$waze__forms__settings$$__module from "./discourse/connectors/category-custom-settings/waze-forms-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$waze__forms__settings$$default
} from "./discourse/connectors/category-custom-settings/waze-forms-settings.gjs";
import * as Mod3 from "./discourse/initializers/waze-forms-initializer";
compatModules["discourse/initializers/waze-forms-initializer"] = Mod3;

export * as discourse$initializers$waze__forms__initializer$$__module from "./discourse/initializers/waze-forms-initializer";
export {
default as discourse$initializers$waze__forms__initializer$$default
} from "./discourse/initializers/waze-forms-initializer";
export default compatModules;
